/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilePreview from "./FilePreview.vue";
import FileBrowser from "./FileBrowser.vue";
import WebLink from "./WebLink.vue";
import GoogleDrivePicker from "../../integrations/google_drive_picker";
import ImageCropper from "./ImageCropper.vue";

const __vue_script__ = {
  name: "FileUploader",
  props: {
    show_upload_button: {
      default: true,
    },
    disable_file_browser: {
      default: false,
    },
    allow_multiple: {
      default: true,
    },
    as_dataurl: {
      default: false,
    },
    doctype: {
      default: null,
    },
    docname: {
      default: null,
    },
    fieldname: {
      default: null,
    },
    folder: {
      default: "Home",
    },
    method: {
      default: null,
    },
    on_success: {
      default: null,
    },
    make_attachments_public: {
      default: null,
    },
    restrictions: {
      default: () => ({
        max_file_size: null, // 2048 -> 2KB
        max_number_of_files: null,
        allowed_file_types: [], // ['image/*', 'video/*', '.jpg', '.gif', '.pdf'],
        crop_image_aspect_ratio: null, // 1, 16 / 9, 4 / 3, NaN (free)
      }),
    },
    attach_doc_image: {
      default: false,
    },
    upload_notes: {
      default: null, // "Images or video, upto 2MB"
    },
  },
  components: {
    FilePreview,
    FileBrowser,
    WebLink,
    ImageCropper,
  },
  data() {
    return {
      files: [],
      is_dragging: false,
      currently_uploading: -1,
      show_file_browser: false,
      show_web_link: false,
      show_image_cropper: false,
      crop_image_with_index: -1,
      trigger_upload: false,
      close_dialog: false,
      hide_dialog_footer: false,
      allow_take_photo: false,
      allow_web_link: true,
      google_drive_settings: {
        enabled: false,
      },
      wrapper_ready: false,
    };
  },
  created() {
    this.allow_take_photo = window.navigator.mediaDevices;
    if (frappe.user_id !== "Guest") {
      frappe.call({
        // method only available after login
        method:
          "frappe.integrations.doctype.google_settings.google_settings.get_file_picker_settings",
        callback: (resp) => {
          if (!resp.exc) {
            this.google_drive_settings = resp.message;
          }
        },
      });
    }
    if (this.restrictions.max_file_size == null) {
      frappe.call("frappe.core.api.file.get_max_file_size").then((res) => {
        this.restrictions.max_file_size = Number(res.message);
      });
    }
    if (this.restrictions.max_number_of_files == null && this.doctype) {
      this.restrictions.max_number_of_files = frappe.get_meta(
        this.doctype
      )?.max_attachments;
    }
  },
  watch: {
    files(newvalue, oldvalue) {
      if (!this.allow_multiple && newvalue.length > 1) {
        this.files = [newvalue[newvalue.length - 1]];
      }
    },
  },
  computed: {
    upload_complete() {
      return (
        this.files.length > 0 &&
        this.files.every(
          (file) => file.total !== 0 && file.progress === file.total
        )
      );
    },
  },
  methods: {
    dragover() {
      this.is_dragging = true;
    },
    dragleave() {
      this.is_dragging = false;
    },
    dropfiles(e) {
      this.is_dragging = false;
      this.add_files(e.dataTransfer.files);
    },
    browse_files() {
      this.$refs.file_input.click();
    },
    on_file_input(e) {
      this.add_files(this.$refs.file_input.files);
    },
    remove_file(file) {
      this.files = this.files.filter((f) => f !== file);
    },
    toggle_image_cropper(index) {
      this.crop_image_with_index = this.show_image_cropper ? -1 : index;
      this.hide_dialog_footer = !this.show_image_cropper;
      this.show_image_cropper = !this.show_image_cropper;
    },
    toggle_all_private() {
      let flag;
      let private_values = this.files.filter((file) => file.private);
      if (private_values.length < this.files.length) {
        // there are some private and some public
        // set all to private
        flag = true;
      } else {
        // all are private, set all to public
        flag = false;
      }
      this.files = this.files.map((file) => {
        file.private = flag;
        return file;
      });
    },
    show_max_files_number_warning(file) {
      console.warn(
        `File skipped because it exceeds the allowed specified limit of ${max_number_of_files} uploads`,
        file
      );
      if (this.doctype) {
        MSG = __(
          'File "{0}" was skipped because only {1} uploads are allowed for DocType "{2}"',
          [file.name, max_number_of_files, this.doctype]
        );
      } else {
        MSG = __(
          'File "{0}" was skipped because only {1} uploads are allowed',
          [file.name, max_number_of_files]
        );
      }
      frappe.show_alert({
        message: MSG,
        indicator: "orange",
      });
    },
    add_files(file_array) {
      let files = Array.from(file_array)
        .filter(this.check_restrictions)
        .map((file) => {
          let is_image = file.type.startsWith("image");
          let size_kb = file.size / 1024;
          return {
            file_obj: file,
            cropper_file: file,
            crop_box_data: null,
            optimize: size_kb > 200 && is_image && !file.type.includes("svg"),
            name: file.name,
            doc: null,
            progress: 0,
            total: 0,
            failed: false,
            request_succeeded: false,
            error_message: null,
            uploading: false,
            private: !this.make_attachments_public,
          };
        });

      // pop extra files as per FileUploader.restrictions.max_number_of_files
      max_number_of_files = this.restrictions.max_number_of_files;
      if (max_number_of_files && files.length > max_number_of_files) {
        files.slice(max_number_of_files).forEach((file) => {
          this.show_max_files_number_warning(file, this.doctype);
        });

        files = files.slice(0, max_number_of_files);
      }

      this.files = this.files.concat(files);
      // if only one file is allowed and crop_image_aspect_ratio is set, open cropper immediately
      if (
        this.files.length === 1 &&
        !this.allow_multiple &&
        this.restrictions.crop_image_aspect_ratio != null
      ) {
        if (!this.files[0].file_obj.type.includes("svg")) {
          this.toggle_image_cropper(0);
        }
      }
    },
    check_restrictions(file) {
      let { max_file_size, allowed_file_types = [] } = this.restrictions;

      let is_correct_type = true;
      let valid_file_size = true;

      if (allowed_file_types && allowed_file_types.length) {
        is_correct_type = allowed_file_types.some((type) => {
          // is this is a mime-type
          if (type.includes("/")) {
            if (!file.type) return false;
            return file.type.match(type);
          }

          // otherwise this is likely an extension
          if (type[0] === ".") {
            return file.name.endsWith(type);
          }
          return false;
        });
      }

      if (max_file_size && file.size != null) {
        valid_file_size = file.size < max_file_size;
      }

      if (!is_correct_type) {
        console.warn("File skipped because of invalid file type", file);
        frappe.show_alert({
          message: __('File "{0}" was skipped because of invalid file type', [
            file.name,
          ]),
          indicator: "orange",
        });
      }
      if (!valid_file_size) {
        console.warn(
          "File skipped because of invalid file size",
          file.size,
          file
        );
        frappe.show_alert({
          message: __('File "{0}" was skipped because size exceeds {1} MB', [
            file.name,
            max_file_size / (1024 * 1024),
          ]),
          indicator: "orange",
        });
      }

      return is_correct_type && valid_file_size;
    },
    upload_files() {
      if (this.show_file_browser) {
        return this.upload_via_file_browser();
      }
      if (this.show_web_link) {
        return this.upload_via_web_link();
      }
      if (this.as_dataurl) {
        return this.return_as_dataurl();
      }
      return frappe.run_serially(
        this.files.map((file, i) => () => this.upload_file(file, i))
      );
    },
    upload_via_file_browser() {
      let selected_file = this.$refs.file_browser.selected_node;
      if (!selected_file.value) {
        frappe.msgprint(__("Click on a file to select it."));
        this.close_dialog = true;
        return Promise.reject();
      }
      this.close_dialog = true;
      return this.upload_file({
        file_url: selected_file.file_url,
      });
    },
    upload_via_web_link() {
      let file_url = this.$refs.web_link.url;
      if (!file_url) {
        frappe.msgprint(__("Invalid URL"));
        this.close_dialog = true;
        return Promise.reject();
      }
      file_url = decodeURI(file_url);
      this.close_dialog = true;
      return this.upload_file({
        file_url,
      });
    },
    return_as_dataurl() {
      let promises = this.files.map((file) =>
        frappe.dom.file_to_base64(file.file_obj).then((dataurl) => {
          file.dataurl = dataurl;
          this.on_success && this.on_success(file);
        })
      );
      this.close_dialog = true;
      return Promise.all(promises);
    },
    upload_file(file, i) {
      this.currently_uploading = i;

      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("loadstart", (e) => {
          file.uploading = true;
        });
        xhr.upload.addEventListener("progress", (e) => {
          if (e.lengthComputable) {
            file.progress = e.loaded;
            file.total = e.total;
          }
        });
        xhr.upload.addEventListener("load", (e) => {
          file.uploading = false;
          resolve();
        });
        xhr.addEventListener("error", (e) => {
          file.failed = true;
          reject();
        });
        xhr.onreadystatechange = () => {
          if (xhr.readyState == XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
              file.request_succeeded = true;
              let r = null;
              let file_doc = null;
              try {
                r = JSON.parse(xhr.responseText);
                if (r.message.doctype === "File") {
                  file_doc = r.message;
                }
              } catch (e) {
                r = xhr.responseText;
              }

              file.doc = file_doc;

              if (this.on_success) {
                this.on_success(file_doc, r);
              }

              if (
                i == this.files.length - 1 &&
                this.files.every((file) => file.request_succeeded)
              ) {
                this.close_dialog = true;
              }
            } else if (xhr.status === 403) {
              file.failed = true;
              let response = JSON.parse(xhr.responseText);
              file.error_message = `Not permitted. ${
                response._error_message || ""
              }`;
            } else if (xhr.status === 413) {
              file.failed = true;
              file.error_message =
                "Size exceeds the maximum allowed file size.";
            } else {
              file.failed = true;
              file.error_message =
                xhr.status === 0
                  ? "XMLHttpRequest Error"
                  : `${xhr.status} : ${xhr.statusText}`;

              let error = null;
              try {
                error = JSON.parse(xhr.responseText);
              } catch (e) {
                // pass
              }
              frappe.request.cleanup({}, error);
            }
          }
        };
        xhr.open("POST", "/api/method/upload_file", true);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader("X-Frappe-CSRF-Token", frappe.csrf_token);

        let form_data = new FormData();
        if (file.file_obj) {
          form_data.append("file", file.file_obj, file.name);
        }
        form_data.append("is_private", +file.private);
        form_data.append("folder", this.folder);

        if (file.file_url) {
          form_data.append("file_url", file.file_url);
        }

        if (file.file_name) {
          form_data.append("file_name", file.file_name);
        }

        if (this.doctype && this.docname) {
          form_data.append("doctype", this.doctype);
          form_data.append("docname", this.docname);
        }

        if (this.fieldname) {
          form_data.append("fieldname", this.fieldname);
        }

        if (this.method) {
          form_data.append("method", this.method);
        }

        if (file.optimize) {
          form_data.append("optimize", true);
        }

        if (this.attach_doc_image) {
          form_data.append("max_width", 200);
          form_data.append("max_height", 200);
        }

        xhr.send(form_data);
      });
    },
    capture_image() {
      const capture = new frappe.ui.Capture({
        animate: false,
        error: true,
      });
      capture.show();
      capture.submit((data_urls) => {
        data_urls.forEach((data_url) => {
          let filename = `capture_${frappe.datetime
            .now_datetime()
            .replaceAll(/[: -]/g, "_")}.png`;
          this.url_to_file(data_url, filename, "image/png").then((file) =>
            this.add_files([file])
          );
        });
      });
    },
    show_google_drive_picker() {
      this.close_dialog = true;
      let google_drive = new GoogleDrivePicker({
        pickerCallback: (data) => this.google_drive_callback(data),
        ...this.google_drive_settings,
      });
      google_drive.loadPicker();
    },
    google_drive_callback(data) {
      if (data.action == google.picker.Action.PICKED) {
        this.upload_file({
          file_url: data.docs[0].url,
          file_name: data.docs[0].name,
        });
      } else if (data.action == google.picker.Action.CANCEL) {
        cur_frm.attachments.new_attachment();
      }
    },
    url_to_file(url, filename, mime_type) {
      return fetch(url)
        .then((res) => res.arrayBuffer())
        .then((buffer) => new File([buffer], filename, { type: mime_type }));
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-uploader",
      on: {
        dragover: function($event) {
          $event.preventDefault()
          return _vm.dragover.apply(null, arguments)
        },
        dragleave: function($event) {
          $event.preventDefault()
          return _vm.dragleave.apply(null, arguments)
        },
        drop: function($event) {
          $event.preventDefault()
          return _vm.dropfiles.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.files.length === 0 &&
                !_vm.show_file_browser &&
                !_vm.show_web_link,
              expression:
                "files.length === 0 && !show_file_browser && !show_web_link"
            }
          ],
          staticClass: "file-upload-area"
        },
        [
          !_vm.is_dragging
            ? _c("div", [
                _c("div", { staticClass: "text-center" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.__("Drag and drop files here or upload from")
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-2 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-file-upload",
                      on: { click: _vm.browse_files }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "30",
                            height: "30",
                            viewBox: "0 0 30 30",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "15",
                              cy: "15",
                              r: "15",
                              fill: "url(#paint0_linear)"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M13.5 22V19",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M16.5 22V19",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M10.5 22H19.5",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M7.5 16H22.5",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M21 8H9C8.17157 8 7.5 8.67157 7.5 9.5V17.5C7.5 18.3284 8.17157 19 9 19H21C21.8284 19 22.5 18.3284 22.5 17.5V9.5C22.5 8.67157 21.8284 8 21 8Z",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "defs",
                            [
                              _c(
                                "linearGradient",
                                {
                                  attrs: {
                                    id: "paint0_linear",
                                    x1: "0",
                                    y1: "0",
                                    x2: "0",
                                    y2: "30",
                                    gradientUnits: "userSpaceOnUse"
                                  }
                                },
                                [
                                  _c("stop", {
                                    attrs: { "stop-color": "#2C9AF1" }
                                  }),
                                  _vm._v(" "),
                                  _c("stop", {
                                    attrs: {
                                      offset: "1",
                                      "stop-color": "#2490EF"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-1" }, [
                        _vm._v(_vm._s(_vm.__("My Device")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "file_input",
                    staticClass: "hidden",
                    attrs: {
                      type: "file",
                      multiple: _vm.allow_multiple,
                      accept: (_vm.restrictions.allowed_file_types || []).join(
                        ", "
                      )
                    },
                    on: { change: _vm.on_file_input }
                  }),
                  _vm._v(" "),
                  !_vm.disable_file_browser
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-file-upload",
                          on: {
                            click: function($event) {
                              _vm.show_file_browser = true
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "30",
                                height: "30",
                                viewBox: "0 0 30 30",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "15",
                                  r: "15",
                                  fill: "#48BB74"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M13.0245 11.5H8C7.72386 11.5 7.5 11.7239 7.5 12V20C7.5 21.1046 8.39543 22 9.5 22H20.5C21.6046 22 22.5 21.1046 22.5 20V14.5C22.5 14.2239 22.2761 14 22 14H15.2169C15.0492 14 14.8926 13.9159 14.8 13.776L13.4414 11.724C13.3488 11.5841 13.1922 11.5 13.0245 11.5Z",
                                  stroke: "white",
                                  "stroke-miterlimit": "10",
                                  "stroke-linecap": "square"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M8.87939 9.5V8.5C8.87939 8.22386 9.10325 8 9.37939 8H20.6208C20.8969 8 21.1208 8.22386 21.1208 8.5V12",
                                  stroke: "white",
                                  "stroke-miterlimit": "10",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(_vm.__("Library")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.allow_web_link
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-file-upload",
                          on: {
                            click: function($event) {
                              _vm.show_web_link = true
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "30",
                                height: "30",
                                viewBox: "0 0 30 30",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "15",
                                  r: "15",
                                  fill: "#ECAC4B"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M12.0469 17.9543L17.9558 12.0454",
                                  stroke: "white",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M13.8184 11.4547L15.7943 9.47873C16.4212 8.85205 17.2714 8.5 18.1578 8.5C19.0443 8.5 19.8945 8.85205 20.5214 9.47873V9.47873C21.1481 10.1057 21.5001 10.9558 21.5001 11.8423C21.5001 12.7287 21.1481 13.5789 20.5214 14.2058L18.5455 16.1818",
                                  stroke: "white",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M11.4547 13.8184L9.47873 15.7943C8.85205 16.4212 8.5 17.2714 8.5 18.1578C8.5 19.0443 8.85205 19.8945 9.47873 20.5214V20.5214C10.1057 21.1481 10.9558 21.5001 11.8423 21.5001C12.7287 21.5001 13.5789 21.1481 14.2058 20.5214L16.1818 18.5455",
                                  stroke: "white",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(_vm.__("Link")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.allow_take_photo
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-file-upload",
                          on: { click: _vm.capture_image }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "30",
                                height: "30",
                                viewBox: "0 0 30 30",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "15",
                                  r: "15",
                                  fill: "#CE315B"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M11.5 10.5H9.5C8.67157 10.5 8 11.1716 8 12V20C8 20.8284 8.67157 21.5 9.5 21.5H20.5C21.3284 21.5 22 20.8284 22 20V12C22 11.1716 21.3284 10.5 20.5 10.5H18.5L17.3 8.9C17.1111 8.64819 16.8148 8.5 16.5 8.5H13.5C13.1852 8.5 12.8889 8.64819 12.7 8.9L11.5 10.5Z",
                                  stroke: "white",
                                  "stroke-linejoin": "round"
                                }
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "16",
                                  r: "2.5",
                                  stroke: "white"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(_vm.__("Camera")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.google_drive_settings.enabled
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-file-upload",
                          on: { click: _vm.show_google_drive_picker }
                        },
                        [
                          _c("svg", { attrs: { width: "30", height: "30" } }, [
                            _c("image", {
                              attrs: {
                                href:
                                  "/assets/frappe/icons/social/google_drive.svg",
                                width: "30",
                                height: "30"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(_vm.__("Google Drive")))
                          ])
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-muted text-medium" }, [
                  _vm._v("\n        " + _vm._s(_vm.upload_notes) + "\n      ")
                ])
              ])
            : _c("div", [
                _vm._v(
                  "\n      " + _vm._s(_vm.__("Drop files here")) + "\n    "
                )
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.files.length &&
                !_vm.show_file_browser &&
                !_vm.show_web_link,
              expression: "files.length && !show_file_browser && !show_web_link"
            }
          ],
          staticClass: "file-preview-area"
        },
        [
          !_vm.show_image_cropper
            ? _c(
                "div",
                { staticClass: "file-preview-container" },
                _vm._l(_vm.files, function(file, i) {
                  return _c("FilePreview", {
                    key: file.name,
                    attrs: { file: file },
                    on: {
                      remove: function($event) {
                        return _vm.remove_file(file)
                      },
                      toggle_private: function($event) {
                        file.private = !file.private
                      },
                      toggle_optimize: function($event) {
                        file.optimize = !file.optimize
                      },
                      toggle_image_cropper: function($event) {
                        return _vm.toggle_image_cropper(i)
                      }
                    }
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.show_upload_button && _vm.currently_uploading === -1
            ? _c("div", { staticClass: "flex align-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm margin-right",
                    on: { click: _vm.upload_files }
                  },
                  [
                    _vm.files.length === 1
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.__("Upload file")) +
                              "\n        "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.__("Upload {0} files", [_vm.files.length])
                              ) +
                              "\n        "
                          )
                        ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-muted text-medium" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.__(
                          "Click on the lock icon to toggle public/private"
                        )
                      ) +
                      "\n      "
                  )
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.show_image_cropper && _vm.wrapper_ready
        ? _c("ImageCropper", {
            attrs: {
              file: _vm.files[_vm.crop_image_with_index],
              fixed_aspect_ratio: _vm.restrictions.crop_image_aspect_ratio
            },
            on: {
              toggle_image_cropper: function($event) {
                return _vm.toggle_image_cropper(-1)
              },
              upload_after_crop: function($event) {
                _vm.trigger_upload = true
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show_file_browser && !_vm.disable_file_browser
        ? _c("FileBrowser", {
            ref: "file_browser",
            on: {
              "hide-browser": function($event) {
                _vm.show_file_browser = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show_web_link
        ? _c("WebLink", {
            ref: "web_link",
            on: {
              "hide-web-link": function($event) {
                _vm.show_web_link = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6eee9990_0", { source: "\n.file-upload-area {\n  min-height: 16rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px dashed var(--dark-border-color);\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  background-color: var(--bg-color);\n}\n.btn-file-upload {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  font-size: var(--text-xs);\n}\n", map: {"version":3,"sources":["frappe/public/js/frappe/file_uploader/FileUploader.vue"],"names":[],"mappings":";AAouBA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,mCAAA;EACA,eAAA;EACA,iCAAA;AACA;AAEA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AACA","file":"FileUploader.vue","sourcesContent":["<template>\n  <div\n    class=\"file-uploader\"\n    @dragover.prevent=\"dragover\"\n    @dragleave.prevent=\"dragleave\"\n    @drop.prevent=\"dropfiles\"\n  >\n    <div\n      class=\"file-upload-area\"\n      v-show=\"files.length === 0 && !show_file_browser && !show_web_link\"\n    >\n      <div v-if=\"!is_dragging\">\n        <div class=\"text-center\">\n          {{ __(\"Drag and drop files here or upload from\") }}\n        </div>\n        <div class=\"mt-2 text-center\">\n          <button class=\"btn btn-file-upload\" @click=\"browse_files\">\n            <svg\n              width=\"30\"\n              height=\"30\"\n              viewBox=\"0 0 30 30\"\n              fill=\"none\"\n              xmlns=\"http://www.w3.org/2000/svg\"\n            >\n              <circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"url(#paint0_linear)\" />\n              <path\n                d=\"M13.5 22V19\"\n                stroke=\"white\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n              <path\n                d=\"M16.5 22V19\"\n                stroke=\"white\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n              <path\n                d=\"M10.5 22H19.5\"\n                stroke=\"white\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n              <path\n                d=\"M7.5 16H22.5\"\n                stroke=\"white\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n              <path\n                d=\"M21 8H9C8.17157 8 7.5 8.67157 7.5 9.5V17.5C7.5 18.3284 8.17157 19 9 19H21C21.8284 19 22.5 18.3284 22.5 17.5V9.5C22.5 8.67157 21.8284 8 21 8Z\"\n                stroke=\"white\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n              <defs>\n                <linearGradient\n                  id=\"paint0_linear\"\n                  x1=\"0\"\n                  y1=\"0\"\n                  x2=\"0\"\n                  y2=\"30\"\n                  gradientUnits=\"userSpaceOnUse\"\n                >\n                  <stop stop-color=\"#2C9AF1\" />\n                  <stop offset=\"1\" stop-color=\"#2490EF\" />\n                </linearGradient>\n              </defs>\n            </svg>\n            <div class=\"mt-1\">{{ __(\"My Device\") }}</div>\n          </button>\n          <input\n            type=\"file\"\n            class=\"hidden\"\n            ref=\"file_input\"\n            @change=\"on_file_input\"\n            :multiple=\"allow_multiple\"\n            :accept=\"(restrictions.allowed_file_types || []).join(', ')\"\n          />\n          <button\n            class=\"btn btn-file-upload\"\n            v-if=\"!disable_file_browser\"\n            @click=\"show_file_browser = true\"\n          >\n            <svg\n              width=\"30\"\n              height=\"30\"\n              viewBox=\"0 0 30 30\"\n              fill=\"none\"\n              xmlns=\"http://www.w3.org/2000/svg\"\n            >\n              <circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#48BB74\" />\n              <path\n                d=\"M13.0245 11.5H8C7.72386 11.5 7.5 11.7239 7.5 12V20C7.5 21.1046 8.39543 22 9.5 22H20.5C21.6046 22 22.5 21.1046 22.5 20V14.5C22.5 14.2239 22.2761 14 22 14H15.2169C15.0492 14 14.8926 13.9159 14.8 13.776L13.4414 11.724C13.3488 11.5841 13.1922 11.5 13.0245 11.5Z\"\n                stroke=\"white\"\n                stroke-miterlimit=\"10\"\n                stroke-linecap=\"square\"\n              />\n              <path\n                d=\"M8.87939 9.5V8.5C8.87939 8.22386 9.10325 8 9.37939 8H20.6208C20.8969 8 21.1208 8.22386 21.1208 8.5V12\"\n                stroke=\"white\"\n                stroke-miterlimit=\"10\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n            </svg>\n            <div class=\"mt-1\">{{ __(\"Library\") }}</div>\n          </button>\n          <button\n            class=\"btn btn-file-upload\"\n            v-if=\"allow_web_link\"\n            @click=\"show_web_link = true\"\n          >\n            <svg\n              width=\"30\"\n              height=\"30\"\n              viewBox=\"0 0 30 30\"\n              fill=\"none\"\n              xmlns=\"http://www.w3.org/2000/svg\"\n            >\n              <circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#ECAC4B\" />\n              <path\n                d=\"M12.0469 17.9543L17.9558 12.0454\"\n                stroke=\"white\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n              <path\n                d=\"M13.8184 11.4547L15.7943 9.47873C16.4212 8.85205 17.2714 8.5 18.1578 8.5C19.0443 8.5 19.8945 8.85205 20.5214 9.47873V9.47873C21.1481 10.1057 21.5001 10.9558 21.5001 11.8423C21.5001 12.7287 21.1481 13.5789 20.5214 14.2058L18.5455 16.1818\"\n                stroke=\"white\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n              <path\n                d=\"M11.4547 13.8184L9.47873 15.7943C8.85205 16.4212 8.5 17.2714 8.5 18.1578C8.5 19.0443 8.85205 19.8945 9.47873 20.5214V20.5214C10.1057 21.1481 10.9558 21.5001 11.8423 21.5001C12.7287 21.5001 13.5789 21.1481 14.2058 20.5214L16.1818 18.5455\"\n                stroke=\"white\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n              />\n            </svg>\n            <div class=\"mt-1\">{{ __(\"Link\") }}</div>\n          </button>\n          <button\n            v-if=\"allow_take_photo\"\n            class=\"btn btn-file-upload\"\n            @click=\"capture_image\"\n          >\n            <svg\n              width=\"30\"\n              height=\"30\"\n              viewBox=\"0 0 30 30\"\n              fill=\"none\"\n              xmlns=\"http://www.w3.org/2000/svg\"\n            >\n              <circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#CE315B\" />\n              <path\n                d=\"M11.5 10.5H9.5C8.67157 10.5 8 11.1716 8 12V20C8 20.8284 8.67157 21.5 9.5 21.5H20.5C21.3284 21.5 22 20.8284 22 20V12C22 11.1716 21.3284 10.5 20.5 10.5H18.5L17.3 8.9C17.1111 8.64819 16.8148 8.5 16.5 8.5H13.5C13.1852 8.5 12.8889 8.64819 12.7 8.9L11.5 10.5Z\"\n                stroke=\"white\"\n                stroke-linejoin=\"round\"\n              />\n              <circle cx=\"15\" cy=\"16\" r=\"2.5\" stroke=\"white\" />\n            </svg>\n            <div class=\"mt-1\">{{ __(\"Camera\") }}</div>\n          </button>\n          <button\n            v-if=\"google_drive_settings.enabled\"\n            class=\"btn btn-file-upload\"\n            @click=\"show_google_drive_picker\"\n          >\n            <svg width=\"30\" height=\"30\">\n              <image\n                href=\"/assets/frappe/icons/social/google_drive.svg\"\n                width=\"30\"\n                height=\"30\"\n              />\n            </svg>\n            <div class=\"mt-1\">{{ __(\"Google Drive\") }}</div>\n          </button>\n        </div>\n        <div class=\"text-muted text-medium\">\n          {{ upload_notes }}\n        </div>\n      </div>\n      <div v-else>\n        {{ __(\"Drop files here\") }}\n      </div>\n    </div>\n    <div\n      class=\"file-preview-area\"\n      v-show=\"files.length && !show_file_browser && !show_web_link\"\n    >\n      <div class=\"file-preview-container\" v-if=\"!show_image_cropper\">\n        <FilePreview\n          v-for=\"(file, i) in files\"\n          :key=\"file.name\"\n          :file=\"file\"\n          @remove=\"remove_file(file)\"\n          @toggle_private=\"file.private = !file.private\"\n          @toggle_optimize=\"file.optimize = !file.optimize\"\n          @toggle_image_cropper=\"toggle_image_cropper(i)\"\n        />\n      </div>\n      <div\n        class=\"flex align-center\"\n        v-if=\"show_upload_button && currently_uploading === -1\"\n      >\n        <button\n          class=\"btn btn-primary btn-sm margin-right\"\n          @click=\"upload_files\"\n        >\n          <span v-if=\"files.length === 1\">\n            {{ __(\"Upload file\") }}\n          </span>\n          <span v-else>\n            {{ __(\"Upload {0} files\", [files.length]) }}\n          </span>\n        </button>\n        <div class=\"text-muted text-medium\">\n          {{ __(\"Click on the lock icon to toggle public/private\") }}\n        </div>\n      </div>\n    </div>\n    <ImageCropper\n      v-if=\"show_image_cropper && wrapper_ready\"\n      :file=\"files[crop_image_with_index]\"\n      :fixed_aspect_ratio=\"restrictions.crop_image_aspect_ratio\"\n      @toggle_image_cropper=\"toggle_image_cropper(-1)\"\n      @upload_after_crop=\"trigger_upload = true\"\n    />\n    <FileBrowser\n      ref=\"file_browser\"\n      v-if=\"show_file_browser && !disable_file_browser\"\n      @hide-browser=\"show_file_browser = false\"\n    />\n    <WebLink\n      ref=\"web_link\"\n      v-if=\"show_web_link\"\n      @hide-web-link=\"show_web_link = false\"\n    />\n  </div>\n</template>\n\n<script>\nimport FilePreview from \"./FilePreview.vue\";\nimport FileBrowser from \"./FileBrowser.vue\";\nimport WebLink from \"./WebLink.vue\";\nimport GoogleDrivePicker from \"../../integrations/google_drive_picker\";\nimport ImageCropper from \"./ImageCropper.vue\";\n\nexport default {\n  name: \"FileUploader\",\n  props: {\n    show_upload_button: {\n      default: true,\n    },\n    disable_file_browser: {\n      default: false,\n    },\n    allow_multiple: {\n      default: true,\n    },\n    as_dataurl: {\n      default: false,\n    },\n    doctype: {\n      default: null,\n    },\n    docname: {\n      default: null,\n    },\n    fieldname: {\n      default: null,\n    },\n    folder: {\n      default: \"Home\",\n    },\n    method: {\n      default: null,\n    },\n    on_success: {\n      default: null,\n    },\n    make_attachments_public: {\n      default: null,\n    },\n    restrictions: {\n      default: () => ({\n        max_file_size: null, // 2048 -> 2KB\n        max_number_of_files: null,\n        allowed_file_types: [], // ['image/*', 'video/*', '.jpg', '.gif', '.pdf'],\n        crop_image_aspect_ratio: null, // 1, 16 / 9, 4 / 3, NaN (free)\n      }),\n    },\n    attach_doc_image: {\n      default: false,\n    },\n    upload_notes: {\n      default: null, // \"Images or video, upto 2MB\"\n    },\n  },\n  components: {\n    FilePreview,\n    FileBrowser,\n    WebLink,\n    ImageCropper,\n  },\n  data() {\n    return {\n      files: [],\n      is_dragging: false,\n      currently_uploading: -1,\n      show_file_browser: false,\n      show_web_link: false,\n      show_image_cropper: false,\n      crop_image_with_index: -1,\n      trigger_upload: false,\n      close_dialog: false,\n      hide_dialog_footer: false,\n      allow_take_photo: false,\n      allow_web_link: true,\n      google_drive_settings: {\n        enabled: false,\n      },\n      wrapper_ready: false,\n    };\n  },\n  created() {\n    this.allow_take_photo = window.navigator.mediaDevices;\n    if (frappe.user_id !== \"Guest\") {\n      frappe.call({\n        // method only available after login\n        method:\n          \"frappe.integrations.doctype.google_settings.google_settings.get_file_picker_settings\",\n        callback: (resp) => {\n          if (!resp.exc) {\n            this.google_drive_settings = resp.message;\n          }\n        },\n      });\n    }\n    if (this.restrictions.max_file_size == null) {\n      frappe.call(\"frappe.core.api.file.get_max_file_size\").then((res) => {\n        this.restrictions.max_file_size = Number(res.message);\n      });\n    }\n    if (this.restrictions.max_number_of_files == null && this.doctype) {\n      this.restrictions.max_number_of_files = frappe.get_meta(\n        this.doctype\n      )?.max_attachments;\n    }\n  },\n  watch: {\n    files(newvalue, oldvalue) {\n      if (!this.allow_multiple && newvalue.length > 1) {\n        this.files = [newvalue[newvalue.length - 1]];\n      }\n    },\n  },\n  computed: {\n    upload_complete() {\n      return (\n        this.files.length > 0 &&\n        this.files.every(\n          (file) => file.total !== 0 && file.progress === file.total\n        )\n      );\n    },\n  },\n  methods: {\n    dragover() {\n      this.is_dragging = true;\n    },\n    dragleave() {\n      this.is_dragging = false;\n    },\n    dropfiles(e) {\n      this.is_dragging = false;\n      this.add_files(e.dataTransfer.files);\n    },\n    browse_files() {\n      this.$refs.file_input.click();\n    },\n    on_file_input(e) {\n      this.add_files(this.$refs.file_input.files);\n    },\n    remove_file(file) {\n      this.files = this.files.filter((f) => f !== file);\n    },\n    toggle_image_cropper(index) {\n      this.crop_image_with_index = this.show_image_cropper ? -1 : index;\n      this.hide_dialog_footer = !this.show_image_cropper;\n      this.show_image_cropper = !this.show_image_cropper;\n    },\n    toggle_all_private() {\n      let flag;\n      let private_values = this.files.filter((file) => file.private);\n      if (private_values.length < this.files.length) {\n        // there are some private and some public\n        // set all to private\n        flag = true;\n      } else {\n        // all are private, set all to public\n        flag = false;\n      }\n      this.files = this.files.map((file) => {\n        file.private = flag;\n        return file;\n      });\n    },\n    show_max_files_number_warning(file) {\n      console.warn(\n        `File skipped because it exceeds the allowed specified limit of ${max_number_of_files} uploads`,\n        file\n      );\n      if (this.doctype) {\n        MSG = __(\n          'File \"{0}\" was skipped because only {1} uploads are allowed for DocType \"{2}\"',\n          [file.name, max_number_of_files, this.doctype]\n        );\n      } else {\n        MSG = __(\n          'File \"{0}\" was skipped because only {1} uploads are allowed',\n          [file.name, max_number_of_files]\n        );\n      }\n      frappe.show_alert({\n        message: MSG,\n        indicator: \"orange\",\n      });\n    },\n    add_files(file_array) {\n      let files = Array.from(file_array)\n        .filter(this.check_restrictions)\n        .map((file) => {\n          let is_image = file.type.startsWith(\"image\");\n          let size_kb = file.size / 1024;\n          return {\n            file_obj: file,\n            cropper_file: file,\n            crop_box_data: null,\n            optimize: size_kb > 200 && is_image && !file.type.includes(\"svg\"),\n            name: file.name,\n            doc: null,\n            progress: 0,\n            total: 0,\n            failed: false,\n            request_succeeded: false,\n            error_message: null,\n            uploading: false,\n            private: !this.make_attachments_public,\n          };\n        });\n\n      // pop extra files as per FileUploader.restrictions.max_number_of_files\n      max_number_of_files = this.restrictions.max_number_of_files;\n      if (max_number_of_files && files.length > max_number_of_files) {\n        files.slice(max_number_of_files).forEach((file) => {\n          this.show_max_files_number_warning(file, this.doctype);\n        });\n\n        files = files.slice(0, max_number_of_files);\n      }\n\n      this.files = this.files.concat(files);\n      // if only one file is allowed and crop_image_aspect_ratio is set, open cropper immediately\n      if (\n        this.files.length === 1 &&\n        !this.allow_multiple &&\n        this.restrictions.crop_image_aspect_ratio != null\n      ) {\n        if (!this.files[0].file_obj.type.includes(\"svg\")) {\n          this.toggle_image_cropper(0);\n        }\n      }\n    },\n    check_restrictions(file) {\n      let { max_file_size, allowed_file_types = [] } = this.restrictions;\n\n      let is_correct_type = true;\n      let valid_file_size = true;\n\n      if (allowed_file_types && allowed_file_types.length) {\n        is_correct_type = allowed_file_types.some((type) => {\n          // is this is a mime-type\n          if (type.includes(\"/\")) {\n            if (!file.type) return false;\n            return file.type.match(type);\n          }\n\n          // otherwise this is likely an extension\n          if (type[0] === \".\") {\n            return file.name.endsWith(type);\n          }\n          return false;\n        });\n      }\n\n      if (max_file_size && file.size != null) {\n        valid_file_size = file.size < max_file_size;\n      }\n\n      if (!is_correct_type) {\n        console.warn(\"File skipped because of invalid file type\", file);\n        frappe.show_alert({\n          message: __('File \"{0}\" was skipped because of invalid file type', [\n            file.name,\n          ]),\n          indicator: \"orange\",\n        });\n      }\n      if (!valid_file_size) {\n        console.warn(\n          \"File skipped because of invalid file size\",\n          file.size,\n          file\n        );\n        frappe.show_alert({\n          message: __('File \"{0}\" was skipped because size exceeds {1} MB', [\n            file.name,\n            max_file_size / (1024 * 1024),\n          ]),\n          indicator: \"orange\",\n        });\n      }\n\n      return is_correct_type && valid_file_size;\n    },\n    upload_files() {\n      if (this.show_file_browser) {\n        return this.upload_via_file_browser();\n      }\n      if (this.show_web_link) {\n        return this.upload_via_web_link();\n      }\n      if (this.as_dataurl) {\n        return this.return_as_dataurl();\n      }\n      return frappe.run_serially(\n        this.files.map((file, i) => () => this.upload_file(file, i))\n      );\n    },\n    upload_via_file_browser() {\n      let selected_file = this.$refs.file_browser.selected_node;\n      if (!selected_file.value) {\n        frappe.msgprint(__(\"Click on a file to select it.\"));\n        this.close_dialog = true;\n        return Promise.reject();\n      }\n      this.close_dialog = true;\n      return this.upload_file({\n        file_url: selected_file.file_url,\n      });\n    },\n    upload_via_web_link() {\n      let file_url = this.$refs.web_link.url;\n      if (!file_url) {\n        frappe.msgprint(__(\"Invalid URL\"));\n        this.close_dialog = true;\n        return Promise.reject();\n      }\n      file_url = decodeURI(file_url);\n      this.close_dialog = true;\n      return this.upload_file({\n        file_url,\n      });\n    },\n    return_as_dataurl() {\n      let promises = this.files.map((file) =>\n        frappe.dom.file_to_base64(file.file_obj).then((dataurl) => {\n          file.dataurl = dataurl;\n          this.on_success && this.on_success(file);\n        })\n      );\n      this.close_dialog = true;\n      return Promise.all(promises);\n    },\n    upload_file(file, i) {\n      this.currently_uploading = i;\n\n      return new Promise((resolve, reject) => {\n        let xhr = new XMLHttpRequest();\n        xhr.upload.addEventListener(\"loadstart\", (e) => {\n          file.uploading = true;\n        });\n        xhr.upload.addEventListener(\"progress\", (e) => {\n          if (e.lengthComputable) {\n            file.progress = e.loaded;\n            file.total = e.total;\n          }\n        });\n        xhr.upload.addEventListener(\"load\", (e) => {\n          file.uploading = false;\n          resolve();\n        });\n        xhr.addEventListener(\"error\", (e) => {\n          file.failed = true;\n          reject();\n        });\n        xhr.onreadystatechange = () => {\n          if (xhr.readyState == XMLHttpRequest.DONE) {\n            if (xhr.status === 200) {\n              file.request_succeeded = true;\n              let r = null;\n              let file_doc = null;\n              try {\n                r = JSON.parse(xhr.responseText);\n                if (r.message.doctype === \"File\") {\n                  file_doc = r.message;\n                }\n              } catch (e) {\n                r = xhr.responseText;\n              }\n\n              file.doc = file_doc;\n\n              if (this.on_success) {\n                this.on_success(file_doc, r);\n              }\n\n              if (\n                i == this.files.length - 1 &&\n                this.files.every((file) => file.request_succeeded)\n              ) {\n                this.close_dialog = true;\n              }\n            } else if (xhr.status === 403) {\n              file.failed = true;\n              let response = JSON.parse(xhr.responseText);\n              file.error_message = `Not permitted. ${\n                response._error_message || \"\"\n              }`;\n            } else if (xhr.status === 413) {\n              file.failed = true;\n              file.error_message =\n                \"Size exceeds the maximum allowed file size.\";\n            } else {\n              file.failed = true;\n              file.error_message =\n                xhr.status === 0\n                  ? \"XMLHttpRequest Error\"\n                  : `${xhr.status} : ${xhr.statusText}`;\n\n              let error = null;\n              try {\n                error = JSON.parse(xhr.responseText);\n              } catch (e) {\n                // pass\n              }\n              frappe.request.cleanup({}, error);\n            }\n          }\n        };\n        xhr.open(\"POST\", \"/api/method/upload_file\", true);\n        xhr.setRequestHeader(\"Accept\", \"application/json\");\n        xhr.setRequestHeader(\"X-Frappe-CSRF-Token\", frappe.csrf_token);\n\n        let form_data = new FormData();\n        if (file.file_obj) {\n          form_data.append(\"file\", file.file_obj, file.name);\n        }\n        form_data.append(\"is_private\", +file.private);\n        form_data.append(\"folder\", this.folder);\n\n        if (file.file_url) {\n          form_data.append(\"file_url\", file.file_url);\n        }\n\n        if (file.file_name) {\n          form_data.append(\"file_name\", file.file_name);\n        }\n\n        if (this.doctype && this.docname) {\n          form_data.append(\"doctype\", this.doctype);\n          form_data.append(\"docname\", this.docname);\n        }\n\n        if (this.fieldname) {\n          form_data.append(\"fieldname\", this.fieldname);\n        }\n\n        if (this.method) {\n          form_data.append(\"method\", this.method);\n        }\n\n        if (file.optimize) {\n          form_data.append(\"optimize\", true);\n        }\n\n        if (this.attach_doc_image) {\n          form_data.append(\"max_width\", 200);\n          form_data.append(\"max_height\", 200);\n        }\n\n        xhr.send(form_data);\n      });\n    },\n    capture_image() {\n      const capture = new frappe.ui.Capture({\n        animate: false,\n        error: true,\n      });\n      capture.show();\n      capture.submit((data_urls) => {\n        data_urls.forEach((data_url) => {\n          let filename = `capture_${frappe.datetime\n            .now_datetime()\n            .replaceAll(/[: -]/g, \"_\")}.png`;\n          this.url_to_file(data_url, filename, \"image/png\").then((file) =>\n            this.add_files([file])\n          );\n        });\n      });\n    },\n    show_google_drive_picker() {\n      this.close_dialog = true;\n      let google_drive = new GoogleDrivePicker({\n        pickerCallback: (data) => this.google_drive_callback(data),\n        ...this.google_drive_settings,\n      });\n      google_drive.loadPicker();\n    },\n    google_drive_callback(data) {\n      if (data.action == google.picker.Action.PICKED) {\n        this.upload_file({\n          file_url: data.docs[0].url,\n          file_name: data.docs[0].name,\n        });\n      } else if (data.action == google.picker.Action.CANCEL) {\n        cur_frm.attachments.new_attachment();\n      }\n    },\n    url_to_file(url, filename, mime_type) {\n      return fetch(url)\n        .then((res) => res.arrayBuffer())\n        .then((buffer) => new File([buffer], filename, { type: mime_type }));\n    },\n  },\n};\n</script>\n<style>\n.file-upload-area {\n  min-height: 16rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px dashed var(--dark-border-color);\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  background-color: var(--bg-color);\n}\n\n.btn-file-upload {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  font-size: var(--text-xs);\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frappe/public/js/frappe/file_uploader/FileUploader.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__